import { GeneralService } from 'src/app/services/general.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralComponent } from 'src/app/shared/general.component';
import { DropDownListDTO } from './../../../entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from './../../../services/notification.service';
import { take } from 'rxjs/operators';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-qua042-card-III',
    templateUrl: './qua042-card-III.component.html',
    styleUrls: ['./qua042-card-III.scss']
})

export class Qua042CardIIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listLinhaEnsaque?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTamanhoSacaria?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public filteredLinhaEnsaqueOptions: Observable<DropDownListDTO[]>;
    public listLinhaEnsaqueOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTurnoEnsaque?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listNumeroSem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public filteredTurnoEnsaqueOptions: Observable<DropDownListDTO[]>;
    public listTurnoEnsaqueOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listNumeroSemOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listStatusProcesso?: Array<DropDownListDTO> = new Array<DropDownListDTO>();


    @Output() objPc003 = new EventEmitter();
    @Output() mkCalc = new EventEmitter();
    @Output() geracaoCodigoEmbalagem = new EventEmitter();
    @Output() calDatesEnsaque = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Dados de Ensaque', false);
        if (this.isBasica) {
            this.formulario = this.formBuilder.group({
                total_sacos: [null, []],
                peso_sessenta_mil_sementes_impressao_kg: [null, [Validators.required]],
                linha_ensaque: [null, [Validators.required]],
                tamanho_da_sacaria: [null, [Validators.required]],
                data_ensaque: [null, [Validators.required, Validators.pattern(this.regexDate)]],
                qtde_sacos_ou_kg: [null, [Validators.required]],
                num_sementes_saco_basica: [null, [Validators.required]],
                peso_total_lote_kg: [null, []],
                codigo_embalagem: [null, []],
                quantidade_embalagens_un: [null, []],
                perdas_embalagens_erro_impressao: [null, [Validators.required]],
                perdas_embalagens_erro_mensagem: [null, [Validators.required]],
                perdas_embalagens_erro_costura: [null, [Validators.required]],
                perdas_embalagens_outras_ocorrencias: [null, [Validators.required]],
                total_perdas_embalagens: [null, []],
                qntd_embalagem_canguru: [null, [Validators.required]],
                inicio_ensaque_data: [null, [Validators.pattern(this.regexDate)]],
                termino_ensaque_data: [null, [Validators.pattern(this.regexDate)]],
                responsavel_pela_conferencia_lote: [null, [Validators.required]],
                responsavel_pelo_ensaque: [null, [Validators.required]],
                responsavel_pelo_apontamento: [null, []],
                turno_ensaque: [null, [Validators.required]],
                descarte_tratado_kg: [null, [Validators.required]],
                data_apontamento: [null, [Validators.minLength(8), Validators.pattern(this.regexDate)]],
                criado_por: [null, []],
                observacao: [null, []],
            })
        }
        else if (this.isComercial) {
            this.formulario = this.formBuilder.group({
                total_sacos: [null, []],
                peso_sessenta_mil_sementes_impressao_kg: [null, []],
                linha_ensaque: [null, []],
                data_ensaque: [null, [Validators.pattern(this.regexDate)]],
                qtde_sacos_ou_kg: [null, []],
                num_sementes_saco: [null, []],
                peso_total_lote_kg: [null, []],
                codigo_embalagem: [null, []],
                quantidade_embalagens_un: [null, []],
                perdas_embalagens_erro_impressao: [null, []],
                perdas_embalagens_erro_costura: [null, []],
                perdas_embalagens_outras_ocorrencias: [null, []],
                total_perdas_embalagens: [null, []],
                inicio_ensaque_data: [null, [Validators.pattern(this.regexDate)]],
                inicio_ensaque_hora: [null, [Validators.pattern(this.regexHour)]],
                termino_ensaque_data: [null, [Validators.pattern(this.regexDate)]],
                termino_ensaque_hora: [null, [Validators.pattern(this.regexHour)]],
                duracao_atividade_ensaque_h: [null, []],
                status: [null, []],
                umidade_prc: [null, []],
                responsavel_pela_conferencia_lote: [null, []],
                responsavel_pelo_ensaque: [null, []],
                responsavel_pelo_apontamento: [null, []],
                silo_tratado_ou_psa: [null, []],
                turno_ensaque: [null, []],
                data_apontamento: [null, [Validators.minLength(8), Validators.pattern(this.regexDate)]],
                hora_apontamento: [null, [Validators.minLength(4), Validators.pattern(this.regexHour)]],
                criado_por: [null, []],
                observacao: [null, []],
            });

        }
        else if (this.isPreBasica) {
            this.formulario = this.formulario = this.formBuilder.group({
                responsavel_pela_conferencia_lote: [null, [Validators.required]],
                responsavel_pelo_ensaque: [null, [Validators.required]],
                turno_ensaque: [null, [Validators.required]],
                responsavel_pelo_apontamento: [null, [Validators.required]],
                data_conferencia_fisica: [null, [Validators.required]],
                data_hora_apontamento: [null, [Validators.required]],
                status_processo: [null, [Validators.required]],
                criado_por: [null, [Validators.required]],
                observacao: [null, []]
            });
        }


    }

    async ngOnInit(): Promise<void> {
        await this.getLists();
    }

    async getLists(): Promise<void> {
        await Promise.all([this.getListLinhaEnsaque(), this.getListTurnoEnsaque(), this.getListNumSemente(), this.getTamanhoSacariaDropdownOptions(), this.getListStatusProcesso()]);
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async getDataPc003(): Promise<void> {
        this.objPc003.emit();
    }
    async changeTamanhoSacaria() {
        this.geracaoCodigoEmbalagem.emit()
    }

    createFilterLinhaEnsaque(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listLinhaEnsaqueOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listLinhaEnsaque = this.listLinhaEnsaqueOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listLinhaEnsaque = this.listLinhaEnsaqueOriginal;
            }
        } else {
            this.listLinhaEnsaque = this.listLinhaEnsaqueOriginal;
        }
    }

    getListLinhaEnsaque(): void {
        let sheet = "qua042", field = "linha_ensaque";
        if (this.isBasica) {
            sheet = "cd003", field = "linha_processamento";
        }
        this.formularioService.getListDropDownList(sheet, field).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listLinhaEnsaque = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listLinhaEnsaqueOriginal = this.listLinhaEnsaque;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    createFilterTurnoEnsaque(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listTurnoEnsaqueOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTurnoEnsaque = this.listTurnoEnsaqueOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTurnoEnsaque = this.listTurnoEnsaqueOriginal;
            }
        } else {
            this.listTurnoEnsaque = this.listTurnoEnsaqueOriginal;
        }
    }

    async getListTurnoEnsaque(): Promise<void> {
        if (!this.isPreBasica) {
            await this.formularioService.getListDropDownList('qua042', 'turno_ensaque').pipe(take(1)).toPromise().then((response: any) => {
                if (!!response?.data) {
                    this.listTurnoEnsaque = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                    this.listTurnoEnsaqueOriginal = this.listTurnoEnsaque;
                }
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, error.message);
            });
        }
        else {
            await this.formularioService.getListDropDownList('qua042', 'turno_ensaque', this.generalService.getLocalStorageDataSite()).pipe(take(1)).toPromise().then((response: any) => {
                if (!!response?.data) {
                    this.listTurnoEnsaque = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                    this.listTurnoEnsaqueOriginal = this.listTurnoEnsaque;
                }
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, error.message);
            });
        }

    }


    createFilterNumSemente(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listNumeroSemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listNumeroSem = this.listNumeroSemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listNumeroSem = this.listNumeroSemOriginal;
            }
        } else {
            this.listNumeroSem = this.listNumeroSemOriginal;
        }
    }


    async getListNumSemente(): Promise<void> {
        let num_sementes_saco = this.isBasica ? 'num_sementes_saco_basica' : 'num_sementes_saco';

        await this.formularioService.getListDropDownList('qua042', num_sementes_saco).pipe(take(1)).toPromise().then((response: any) => {

            if (!!response?.data) {
                this.listNumeroSem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listNumeroSemOriginal = this.listNumeroSem;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    fillPackagingCode() {
        const sizeSacaria = this.formulario.get('tamanho_da_sacaria').value
        if (sizeSacaria === 'P - FÊMEA') {
            this.formulario.get('codigo_embalagem').setValue('30395933');
        } else if (sizeSacaria === 'M - FÊMEA') {
            this.formulario.get('codigo_embalagem').setValue('30395932')
        } else if (sizeSacaria === 'G - FÊMEA') {
            this.formulario.get('codigo_embalagem').setValue('30395988');
        } else if (sizeSacaria === 'P - POLINIZADOR') {
            this.formulario.get('codigo_embalagem').setValue('30395928');
        } else if (sizeSacaria === 'M - POLINIZADOR') {
            this.formulario.get('codigo_embalagem').setValue('30395989');
        } else if (sizeSacaria === 'G - POLINIZADOR') {
            this.formulario.get('codigo_embalagem').setValue('30395987');
        } else if (sizeSacaria === 'P - EXPERIMENTAL') {
            this.formulario.get('codigo_embalagem').setValue('30395990');
        } else if (sizeSacaria === 'M - EXPERIMENTAL') {
            this.formulario.get('codigo_embalagem').setValue('30395991');
        } else if (sizeSacaria === 'G - EXPERIMENTAL') {
            this.formulario.get('codigo_embalagem').setValue('30395992');
        }
        const pack = this.formulario.get('codigo_embalagem').value
        console.log(sizeSacaria, pack)
    }



    getTamanhoSacariaDropdownOptions(): void {
        this.formularioService
            .getListDropDownList('qua042', 'tamanho_da_sacaria')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listTamanhoSacaria = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    this.setColorsBasedOnOptions();
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, error.message);
            });
    }


    getListStatusProcesso(): void {
        if(this.isPreBasica){
            this.formularioService
            .getListDropDownList('qua042', 'status_processo')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listStatusProcesso = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    if(this.listStatusProcesso.length > 0){
                        this.formulario?.get('status_processo').setValue(this.listStatusProcesso[0].name);
                    }
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, error.message);
            });
        }
    }

    setColorsBasedOnOptions(): void {
        if (!this.listTamanhoSacaria) return;

        this.listTamanhoSacaria.forEach((option: any) => {
            const sizeSacaria = option.name.toUpperCase();

            if (sizeSacaria.includes('FÊMEA')) {
                option.colorClass = 'red-text';
            } else if (sizeSacaria.includes('POLINIZADOR')) {
                option.colorClass = 'blue-text';
            } else if (sizeSacaria.includes('EXPERIMENTAL')) {
                option.colorClass = 'black-text';
            }
        });
    }

    calcDates($event): void {
        this.calDatesEnsaque.emit();
    }
}



